export const en = {
    title: 'Access request was rejected',
    description: "Contact your company's coordinator",
};
